import { alpha, styled } from "@mui/material";
import IconButton from "components/IconButton";

const AutoplayVideoToggleButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  bottom: theme.spacing(1),
  color: theme.palette.common.white,
  backgroundColor: alpha(theme.palette.common.black, 0.6),

  "&:hover": {
    backgroundColor: alpha(theme.palette.common.black, 0.8),
  },

  "&:focus-visible": {
    outline: `2px solid ${theme.palette.common.white}`,
    outlineOffset: "2px",
  },
}));

export default AutoplayVideoToggleButton;
